import React from 'react';
import Rx from 'rx';

import './slider.scss';

import {
  MOUSE_START,
  MOUSE_MOVE,
  MOUSE_END,
  getClientX
} from '../../utils/mouse';

interface IProps {
  defaultValue?: number;
  onChange?: (value: number) => void;
}

interface IState {
  value: number;
  left: number;
}

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

class Slider extends React.Component<IProps, IState> {
  private rectTrack: ClientRect;
  private rectHandle: ClientRect;
  private snapWidth: number;
  private leftOffset: number;
  public state = { left: 0, value: -1 };

  private slider: HTMLDivElement;
  public handle: HTMLDivElement;
  public track: HTMLUListElement;

  private mouseDownObservable;
  private mouseDragSubscription;

  private maxValue: number = 11;

  componentDidMount() {
    this.setupTrackValues();

    this.mouseDownObservable = Rx.Observable.fromEvent(
      this.slider,
      MOUSE_START
    );
    const mouseMove = Rx.Observable.fromEvent(document, MOUSE_MOVE);
    const mouseUp = Rx.Observable.fromEvent(document, MOUSE_END);
    const resize = Rx.Observable.fromEvent(window, 'resize');

    const mouseDrag = this.mouseDownObservable.selectMany(() => {
      return mouseMove.takeUntil(mouseUp);
    });

    resize.subscribe(() => {
      this.setupTrackValues();
      this.setValue(this.state.value);
    });

    this.mouseDragSubscription = mouseDrag.subscribe(event => {
      this.handleMove(event);
    });

    this.setValue(this.props.defaultValue);
  }

  componentWillUnmount() {
    try {
      this.mouseDownObservable();
      this.mouseDragSubscription();
    } catch (error) {}
  }

  private handleMove(event) {
    const left = clamp(
      getClientX(event) - this.leftOffset,
      this.rectTrack.left - this.leftOffset,
      this.rectTrack.right - this.leftOffset
    );

    const value = clamp(
      Math.round(left / this.snapWidth),
      0,
      this.maxValue - 1
    );

    this.setValue(value);
  }

  private setupTrackValues() {
    if (this.track && this.track.children) {
      this.leftOffset = this.track.children[0].getBoundingClientRect().left;
      this.rectTrack = this.track.getBoundingClientRect();
      this.rectHandle = this.handle.getBoundingClientRect();
      this.snapWidth = this.rectTrack.width / this.maxValue;
    }
  }

  public setValue(value: number) {
    if (value != -1 && value === this.state.value) {
      return;
    }

    const targetIndex = value !== -1 ? value : Math.floor(this.maxValue / 2);
    const targetRect = this.track.children[targetIndex].getBoundingClientRect();
    const leftSnap =
      targetRect.left -
      this.slider.getBoundingClientRect().left +
      targetRect.width / 2;

    this.setState({
      value,
      left: leftSnap - this.rectHandle.width / 2
    });

    this.props.onChange(value);
  }

  render() {
    return (
      <div className="c-slider" ref={ref => (this.slider = ref)}>
        <div
          className={`c-slider__handle c-slider__item  c-slider__item--${this.state.value}`}
          style={{
            left: this.state.left
          }}
          ref={ref => (this.handle = ref)}
        />
        <ul
          className="c-slider__track o-list-bare"
          ref={ref => (this.track = ref)}
        >
          {Array.from(Array(this.maxValue).keys()).map(v => (
            <li
              key={v}
              onClick={() => this.setValue(v)}
              className="c-slider__track-item o-list-bare__item"
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/slider/slider.tsx